export default __webpack_public_path__ + "static/grenette-bold-italic-pro-2f0b78fa38364866a6d2c6d4a38f3c96.woff";